package br.com.texeratx.boardgametimeapp.core.di

import br.com.texeratx.boardgametimeapp.core.active_match.ActiveMatchStorage
import br.com.texeratx.boardgametimeapp.core.active_match.getPlatformActiveMatchStorage
import br.com.texeratx.boardgametimeapp.core.i18n.LanguageManager
import br.com.texeratx.boardgametimeapp.core.storage.LanguageStorage
import br.com.texeratx.boardgametimeapp.core.storage.ThemeStorage
import br.com.texeratx.boardgametimeapp.core.storage.TokenStorage
import br.com.texeratx.boardgametimeapp.core.storage.getPlatformTokenStorage
import br.com.texeratx.boardgametimeapp.core.storage.provideLanguageStorage
import br.com.texeratx.boardgametimeapp.core.storage.provideThemeStorage
import br.com.texeratx.boardgametimeapp.core.theme.ThemeManager
import org.koin.dsl.module

val platformModule = module {
    single<TokenStorage> { getPlatformTokenStorage() }

    single<ActiveMatchStorage> { getPlatformActiveMatchStorage() }

    single<LanguageStorage> { provideLanguageStorage() }
    single { LanguageManager(get()) }

    single<ThemeStorage> { provideThemeStorage() }
    single { ThemeManager(get()) }
}
